export default __webpack_public_path__ + "static/media/Group 2664@2x.3edea474.png";